import { defineMessages } from 'react-intl';

export default defineMessages({
    pageHeader: {
        id: 'adac.my-documents-page.ADAC Ambulance service',
        defaultMessage: 'ADAC Ambulance service'
    },
    documentsSent: {
        id: 'adac.my-documents-page.Documents sent to ADAC',
        defaultMessage: 'Documents sent to ADAC'
    },
    documentsReceived: {
        id: 'adac.my-documents-page.Documents received from ADAC',
        defaultMessage: 'Documents received from ADAC'
    },
    goBack: {
        id: 'adac.my-documents-page.Go back',
        defaultMessage: 'Go back'
    },
    finish: {
        id: 'adac.my-documents-page.Finish',
        defaultMessage: 'Finish'
    },
    updateDocumentsFailedTitle: {
        id: 'adac.my-documents-page.Sorry!',
        defaultMessage: 'Sorry!'
    },
    updateDocumentsFailed: {
        id: 'adac.my-documents-page.Unfortunately, the already uploaded...',
        defaultMessage: 'Unfortunately, the already uploaded documents cannot be displayed at the moment.'
    },
    uploadMore: {
        id: 'adac.my-documents-page.Upload more documents',
        defaultMessage: 'Upload more documents'
    },
    dateSent: {
        id: 'adac.my-documents-page.Date sent',
        defaultMessage: 'Date sent'
    },
    typesInfo: {
        id: 'adac.my-documents-page.Please note that only pdf documents and image files (e.g. jpg, png, heic, bmp) can be uploaded',
        defaultMessage: 'Please note that only pdf documents and image files (e.g. jpg, png, heic, bmp) can be uploaded'
    },
    downloadDocument: {
        id: 'adac.my-documents-page.Download document',
        defaultMessage: 'Download document'
    }
});
